import { repositoryHost } from "@/repositories";
import { serviceHost } from "@/services";
import { useQuery } from "@tanstack/react-query";

const databaseService = serviceHost.getDatabaseService();
const customerRepository =
  repositoryHost.getCustomerRepository(databaseService);

export const useGetCustomerById = (customerId: string) => {
  return useQuery({
    queryKey: ["customerId", customerId],
    queryFn: async () => {
      return customerRepository.get({ id: customerId });
    },
    enabled: customerId.length > 0,
  });
};
